namespace TabAurous.Inventory {
    export interface RepairTaxRow {
        TransTaxId?: number;
        TransId?: number;
        HSN?: string;
        ProductTypeId?: number;
        NetAmount?: number;
        TaxId?: number;
        TaxRate?: number;
        TaxAmount?: number;
        CessId?: number;
        CessRate?: number;
        CessAmount?: number;
        CCTaxAmount?: number;
        TaxType?: string;
        TaxName?: string;
        LedgerId?: number;
        OutputLedgerId?: number;
        InputRCMLedgerId?: number;
        OutputRCMLedgerId?: number;
        TaxLedgerId?: number;
        CessLedgerId?: number;
        Code?: string;
        VoucherNo?: string;
        LedgerName?: string;
        PartyTax?: string;
        ECommGST?: string;
        TransDate?: string;
        GrossAmount?: number;
        ReverseCharge?: string;
        InvoiceType?: string;
        IntegratedTaxAmount?: number;
        CentralTaxAmount?: number;
        StateTaxAmount?: number;
        EligibilityForITC?: string;
        State?: string;
        B2CSType?: string;
    }

    export namespace RepairTaxRow {
        export const idProperty = 'TransTaxId';
        export const nameProperty = 'HSN';
        export const localTextPrefix = 'Repair.RepairTax';
        export const deletePermission = 'Inventory:Repair:Delete';
        export const insertPermission = 'Inventory:Repair:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:Repair:Edit';

        export declare const enum Fields {
            TransTaxId = "TransTaxId",
            TransId = "TransId",
            HSN = "HSN",
            ProductTypeId = "ProductTypeId",
            NetAmount = "NetAmount",
            TaxId = "TaxId",
            TaxRate = "TaxRate",
            TaxAmount = "TaxAmount",
            CessId = "CessId",
            CessRate = "CessRate",
            CessAmount = "CessAmount",
            CCTaxAmount = "CCTaxAmount",
            TaxType = "TaxType",
            TaxName = "TaxName",
            LedgerId = "LedgerId",
            OutputLedgerId = "OutputLedgerId",
            InputRCMLedgerId = "InputRCMLedgerId",
            OutputRCMLedgerId = "OutputRCMLedgerId",
            TaxLedgerId = "TaxLedgerId",
            CessLedgerId = "CessLedgerId",
            Code = "Code",
            VoucherNo = "VoucherNo",
            LedgerName = "LedgerName",
            PartyTax = "PartyTax",
            ECommGST = "ECommGST",
            TransDate = "TransDate",
            GrossAmount = "GrossAmount",
            ReverseCharge = "ReverseCharge",
            InvoiceType = "InvoiceType",
            IntegratedTaxAmount = "IntegratedTaxAmount",
            CentralTaxAmount = "CentralTaxAmount",
            StateTaxAmount = "StateTaxAmount",
            EligibilityForITC = "EligibilityForITC",
            State = "State",
            B2CSType = "B2CSType"
        }
    }
}
